function preloadImageAndShowAlert(src, callback) {
    var img = new Image();
    img.onload = function() {
        callback();
    };
    img.onerror = function() {
        callback();
    };
    img.src = src;
}

function showLoader() {
    $('#loader').addClass('loader-active');
}

function hideLoader() {
    $('#loader').removeClass('loader-active').hide();
}

$(document).ready(function() {

    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
            'Accept': 'application/json'
        }
    });

    var loginForm = $('#loginForm');
    var submitButton = loginForm.find('#loginButton');
    submitButton.prop('disabled', false);

    $('#login_email').on('input', function() {
        resetLoginForm();
    });

    function resetLoginForm() {
        $('#loginPasswordFields').hide();
        $('#loginCodeField').hide();
        $('#validEmailMessage').hide();
        $('#invalidEmailMessage').hide();
        $('#forgotPasswordLogin').hide();
        $('#forgotPasswordLinkLogin').hide();
        $('#login_password').val('');
        $('#login_code_login').val('');
        //submitButton.text(window.translations.login);
        submitButton.off('click').on('click', checkEmailLogin);
    }

    function checkEmailLogin(e) {
        e.preventDefault();

        var emailValue = $('#login_email').val();

        $.post('/check-email', {
            email: emailValue
        }, function(data) {

            if (data.exists === false) {
                $('#invalidEmailMessage').show();
                $('#validEmailMessage').hide();
                Swal.fire({
                    title: window.translations.error,
                    text: window.translations.invalid_email,
                    icon: 'error',
                    confirmButtonText: window.translations.close
                });

            } else {
                $('#loginPasswordFields').show();
                //$('#validEmailMesage').show();
                $('#forgotPasswordLinkLogin').show();
                $('#forgotPasswordLogin').show();
                $('#invalidEmailMessage').hide();
                //submitButton.text(window.translations.login);
                submitButton.off('click').on('click', handleLoginOnly);
            }
        }).fail(function(jqXHR, textStatus, errorThrown) {
            Swal.fire({
                title: window.translations.error,
                text: window.translations.verify_email_error,
                icon: 'error',
                confirmButtonText: window.translations.close
            });
        });
    }

    submitButton.on('click', checkEmailLogin);

    function handleLoginOnly(e) {
        e.preventDefault();
    
        var emailValue = $('#login_email').val();
        var passwordValue = $('#login_password').val();
        var loginCode = $('#login_code_login').val();
        showLoader();
    
        var postData = {
            email: emailValue,
            simple_login: true
        };
    
        if (loginCode) {
            postData.login_code = loginCode;
        } else if (passwordValue) {
            postData.password = passwordValue;
        } else { 
            Swal.fire({
                title: window.translations.error,
                text: window.translations.password_or_code_required,
                icon: 'error',
                confirmButtonText: window.translations.close
            });
            hideLoader();
            return;
        }
    
        var loginUrl = loginCode ? '/verify-login-code' : '/login'; 
    
        $.post(loginUrl, postData, function(data) {
            hideLoader(); 
    
            if (data.success) {
                Swal.fire({
                    title: window.translations.login_success,
                    icon: 'success',
                    confirmButtonText: window.translations.thanks
                }).then((result) => {
                    if (result.isConfirmed) {
                        location.reload();
                    }
                });
            } else {
                Swal.fire({
                    text: data.message,
                    icon: 'error',
                    confirmButtonText: window.translations.close
                }).then((result) => {
                    if (result.isConfirmed) {
                        location.reload();
                    }
                });
            }
        }).fail(function(jqXHR, textStatus, errorThrown) {
            hideLoader();
    
            var errorMessage;
    
            if (loginCode) {
                errorMessage = 'The login code is incorrect or expired.';
            } else {
                errorMessage = window.translations.invalid_password;
                $('#login_password').addClass('is-invalid');
            }
    
            Swal.fire({
                title: window.translations.error,
                text: errorMessage,
                icon: 'error',
                confirmButtonText: window.translations.try_again
            });
        });
    }
    
    $('#forgotPasswordLinkLogin').on('click', function(e) {
        e.preventDefault();

        var emailValue = $('#login_email').val();

        preloadImageAndShowAlert('/gif/sending-email.gif', function() {
            Swal.fire({
                title: window.translations.sending_email,
                text: window.translations.sending_code,
                imageUrl: '/gif/sending-email.gif',
                imageWidth: 80,
                imageHeight: 80,
                showConfirmButton: false,
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });

            $.post('/send-login-code', {
                email: emailValue
            }, function(data) {
                Swal.close();
                Swal.fire({
                    title: window.translations.check_your_email,
                    text: window.translations.login_code_sent,
                    icon: 'info',
                    confirmButtonText: window.translations.continue
                });

                $('#loginCodeField').show();
                $('#loginPasswordFields').hide();
                $('#forgotPasswordLogin').hide();
                $('#forgotPasswordLinkLogin').hide();

                //submitButton.text(window.translations.login_with_code);
                submitButton.off('click').on('click', handleLoginOnly);
            }).fail(function(jqXHR, textStatus, errorThrown) {
                Swal.close();
                Swal.fire({
                    title: window.translations.error,
                    text: window.translations.error_sending_code,
                    icon: 'error',
                    confirmButtonText: window.translations.try_again
                });
            });
        });
    });
});